import { Provider } from 'react-redux';
import { rootStore} from './rootStore';

export default (props) => {
    return (
        <Provider store={rootStore}>
            {props.children}
        </Provider>
    );
}